import { H5, InfoIcon, ParagraphBody } from '@by-miles/bymiles-styles'
import React, { useContext } from 'react'

import { ProviderContext } from '../../Provider'
import { CoverHighLightsStyles } from './CoverHighlightsStyles'

interface CoverHighlightsProps {
  insurer: string
  coverage: string
}

export const CoverHighLights = ({ insurer, coverage }: CoverHighlightsProps) => {
  const { handleShowModal } = useContext(ProviderContext)

  return (
    <CoverHighLightsStyles>
      <div className="border LoNotSensitive">
        <H5 className="item-one">Comprehensive</H5>
      </div>
      <div className="border LoNotSensitive">
        <H5 className="item-two">{coverage}</H5>
        <div className="coverage-use-container">
          <ParagraphBody className="coverage-use-text">What does this cover?</ParagraphBody>
          <div onClick={() => handleShowModal('policy-usage')}>
            <InfoIcon />
          </div>
        </div>
      </div>

      <div className="border LoNotSensitive">
        <H5 className="item-three">
          Underwritten by <br />
          {insurer}
        </H5>
      </div>
    </CoverHighLightsStyles>
  )
}
